<app-card>
  <div class="register-container">
    <div class="register-form-wrapper" *ngIf="!registrationSuccess">
      <h1>{{ 'auth.register.title' | transloco }}</h1>

      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <!-- Only show Google SSO button if NOT already a Google user -->
        <ng-container *ngIf="!isGoogle">
          <!-- Google SSO Button -->
          <div
            class="col-sm btn btn-sm border d-flex align-items-start justify-content-center custom-btn"
            (click)="googleAuth()"
            style="margin-bottom: 1rem; cursor: pointer">
            <img class="me-2" alt="" src="assets/img/google.svg" />
            <p class="mb-0">{{ 'auth.register.signUpWithGoogle' | transloco }}</p>
          </div>

          <!-- Divider OR -->
          <div>
            <div class="row mt-3 mb-3 align-items-center">
              <div class="col-5 d-flex"><hr class="w-100" /></div>
              <div class="col-2 text-center middle-text opacity_text">
                <h3>{{ 'auth.login.or' | transloco }}</h3>
              </div>
              <div class="col-5"><hr class="w-100" /></div>
            </div>
          </div>
        </ng-container>

        <div class="form-row">
          <app-input
            [label]="'auth.register.firstName' | transloco"
            formControlName="firstName"
            name="firstName"
            autocomplete="given-name"
            [required]="true"
            [placeholder]="'auth.register.firstNamePlaceholder' | transloco"
            [errorMessage]="getErrorMessage('firstName')"></app-input>
        </div>

        <div class="form-row">
          <app-input
            [label]="'auth.register.lastName' | transloco"
            formControlName="lastName"
            name="lastName"
            autocomplete="family-name"
            [required]="true"
            [placeholder]="'auth.register.lastNamePlaceholder' | transloco"
            [errorMessage]="getErrorMessage('lastName')"></app-input>
        </div>

        <div class="form-row">
          <app-input
            [label]="'auth.register.email' | transloco"
            formControlName="email"
            name="email"
            autocomplete="email"
            [required]="true"
            [placeholder]="'auth.register.emailPlaceholder' | transloco"
            [errorMessage]="getErrorMessage('email')"></app-input>
        </div>

        <!-- <div class="form-row">
        <app-input
          [label]="'register.cityCountry' | transloco"
          formControlName="cityCountry"
          name="cityCountry"
          autocomplete="address-level2"
          [placeholder]="'Ex. London'"
          [errorMessage]="getErrorMessage('cityCountry')"
        ></app-input>
      </div> -->

        <!-- Only show password fields if NOT Google user -->
        <ng-container *ngIf="!isGoogle">
          <div class="form-row">
            <div class="password-input-container">
              <app-input
                [label]="'auth.register.password' | transloco"
                formControlName="password"
                name="password"
                [required]="true"
                [type]="showPassword ? 'text' : 'password'"
                [placeholder]="'auth.register.passwordPlaceholder' | transloco"
                [errorMessage]="getErrorMessage('password')"
                [hasIcon]="true"
                [iconPosition]="'right'"></app-input>
              <app-button tabindex="-1" [icon]="true" type="button" variant="outline" color="secondary" (click)="togglePasswordVisibility()">
                @if(showPassword){
                <i class="fas fa-eye-slash"></i>
                } @else {
                <i class="fas fa-eye"></i>
                }
              </app-button>
            </div>

            <!-- Password strength indicator -->
            <app-password-strength [password]="registerForm.get('password')?.value"></app-password-strength>
          </div>

          <div class="form-row">
            <div class="password-input-container">
              <app-input
                [label]="'auth.register.confirmPassword' | transloco"
                formControlName="confirmPassword"
                name="confirmPassword"
                [required]="true"
                [type]="showConfirmPassword ? 'text' : 'password'"
                [placeholder]="'auth.register.confirmPasswordPlaceholder' | transloco"
                [errorMessage]="getErrorMessage('confirmPassword')"
                [hasIcon]="true"
                [iconPosition]="'right'"></app-input>
              <app-button tabindex="-1" [icon]="true" type="button" variant="outline" color="secondary" (click)="toggleConfirmPasswordVisibility()">
                @if(showConfirmPassword){
                <i class="fas fa-eye-slash"></i>
                } @else {
                <i class="fas fa-eye"></i>
                }
              </app-button>
            </div>
          </div>
        </ng-container>

        <div class="form-row">
          <app-input
            [label]="'auth.register.inviteCode' | transloco"
            formControlName="inviteCode"
            name="inviteCode"
            [hint]="'auth.register.inviteCodeHint' | transloco"
            [placeholder]="''"
            [errorMessage]="getErrorMessage('inviteCode')"></app-input>
        </div>

        <div class="form-row checkbox-row consent-row">
          <app-input-checkbox formControlName="aiMatching" [id]="'aiMatching'" [name]="'aiMatching'">
            <strong class="consent-row__title">{{ 'auth.register.aiMatching' | transloco }}</strong>
          </app-input-checkbox>
          <p class="consent-row__description">
            {{ 'auth.register.aiMatchingDescription' | transloco }}
            <a class="checkbox-link" [routerLink]="['/', languageRoutingService.getCurrentLanguage(), 'privacy-policy']" target="_blank">
              {{ 'auth.register.privacyPolicy1' | transloco }}
            </a>
          </p>
        </div>

        <div class="form-row checkbox-row consent-row">
          <app-input-checkbox formControlName="newsletter" [id]="'newsletter'" [name]="'newsletter'">
            <strong class="consent-row__title">{{ 'auth.register.newsletterShort' | transloco }}</strong>
          </app-input-checkbox>
          <p class="consent-row__description">
            {{ 'auth.register.newsletter' | transloco }}
            <a class="checkbox-link" [routerLink]="['/', languageRoutingService.getCurrentLanguage(), 'privacy-policy']" target="_blank">
              {{ 'auth.register.privacyPolicy' | transloco }}
            </a>
          </p>
        </div>

        <div class="form-row checkbox-row">
          <app-input-checkbox formControlName="termsAccepted" [id]="'termsAccepted'" [name]="'termsAccepted'">
            {{ 'auth.register.termsAccepted' | transloco }}
            <a class="checkbox-link" [routerLink]="['/', languageRoutingService.getCurrentLanguage(), 'terms-of-use']" target="_blank">
              {{ 'auth.register.termsOfUse' | transloco }}
            </a>
            {{ 'auth.register.and' | transloco }}
            <a class="checkbox-link" [routerLink]="['/', languageRoutingService.getCurrentLanguage(), 'privacy-policy']" target="_blank">
              {{ 'auth.register.privacyPolicy' | transloco }}
            </a>
          </app-input-checkbox>
          <div *ngIf="registerForm.get('termsAccepted')?.touched && registerForm.get('termsAccepted')?.invalid" class="error-message">
            {{ getErrorMessage('termsAccepted') }}
          </div>
        </div>

        <div class="form-actions">
          <app-alert-card *ngIf="registerError" [message]="registerError" [dismissible]="true"></app-alert-card>

          <app-button [block]="true" [type]="'submit'" [disabled]="isSubmitting">
            {{ 'auth.register.submit' | transloco }}
          </app-button>
        </div>

        <div class="login-link">
          {{ 'auth.register.alreadyHaveAccount' | transloco }}
          <a [routerLink]="['/', languageRoutingService.getCurrentLanguage(), 'login']">{{ 'auth.register.login' | transloco }}</a>
        </div>
      </form>
    </div>

    <!-- Success Message after registration -->
    <div class="success-message-container" *ngIf="registrationSuccess">
      <div class="success-icon">
        <i class="fas fa-check-circle"></i>
      </div>

      <!-- Success message for Google SSO registration -->
      <ng-container *ngIf="isGoogleRegistration">
        <h2>{{ 'auth.register.success' | transloco }}</h2>
        <p>{{ 'auth.register.googleSuccess' | transloco }}</p>
        <div class="success-actions">
          <div class="login-link">
            <a [routerLink]="['/', languageRoutingService.getCurrentLanguage(), 'login']">{{ 'auth.register.backToLogin' | transloco }}</a>
          </div>
        </div>
      </ng-container>

      <!-- Success message for email/password registration -->
      <ng-container *ngIf="!isGoogleRegistration">
        <h2>{{ 'auth.register.success' | transloco }}</h2>
        <h3>{{ 'auth.register.success-verify' | transloco }}</h3>
        <p>{{ 'auth.register.checkEmail' | transloco }}</p>
        <div class="success-actions">
          <div class="login-link">
            <a [routerLink]="['/', languageRoutingService.getCurrentLanguage(), 'login']">{{ 'auth.register.backToLogin' | transloco }}</a>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</app-card>
